<template>
    <div class="home">


        <b-container fluid>
            <b-row>
              <b-col>
                <h1>Affirmation</h1>
              </b-col>
            </b-row>
            <b-row>
                <b-alert variant="danger" show v-if="this.limit && application.subCategory === 'TEMPORARY'">
                    <p>Our records indicate that you are attempting to supervise more than 4 temporary piercers or/and more than 2 temporary tattooists. You will need to submit a supervisory plan for each of your current and pending supervisees.</p>
                </b-alert>
            </b-row>

            <div class="card">
              <div class="card-header">Application Affirmation</div>
              <div class="card-body">  
                  <b-row v-if="application.subCategory === 'TEMPORARY'">
                    <b-col>
                      <p>
                        I certify that I am a licensed body art technician and that I will supervise this applicant in a licensed establishment.  I have read 
                        Minnesota Statutes, Chapter 146B.  I understand that a temporary technician license expires one (1) year from issuance.  I understand 
                        that I am responsible the below applicant until MDH receives my written and signed statement that I wish to cease supervision or until
                        the expiration of the temporary technician license.
                      </p>
                    </b-col>
                  </b-row>

                  <b-row  v-if="application.subCategory === 'GUEST'">
                    <b-col>
                      <p>
                        I certify that I am a licensed body art technician and that I will sponsor this applicant in a licensed establishment.  I have read 
                        Minnesota Statutes, Chapter 146B.  I understand that a Guest Artist cannot work for more than 30 days in one calendar year period without 
                        applying for a technician license. I understand 
                        that I am responsible the below applicant until MDH receives my written and signed statement that I wish to cease sponsorship or until
                        the expiration of the Guest Artist license.
                      </p>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12">
                        <b-dropdown text="Affirmation Decision" variant="primary" class="m-2">
                          <b-dropdown-item-button @click="showAffirmModal">Affirm</b-dropdown-item-button>
                          <b-dropdown-item-button @click="showDenyModal">Do not Affirm</b-dropdown-item-button>
                        </b-dropdown>
                    </b-col>
                  </b-row>
              </div>
            </div>

            <div class="card">
              <div class="card-header">Applicant Information</div>
                <div class="card-body">
                
                  <b-row>
                      <b-col cols="4"><BaseTextOutput label="Last Name" :value="application.lastName"/></b-col>
                      <b-col cols="4"><BaseTextOutput label="First Name" :value="application.firstName"/></b-col>
                      <b-col cols="4"><BaseTextOutput label="Middle Name" :value="application.middleName"/></b-col>
                  </b-row>

                  <Address :value="application.address" :international="application.international"/>

                  <b-row class="mt-3">
                      <b-col cols="4"><BaseTextOutput label="Preferred Phone" :value="application.preferredPhone"/></b-col>
                      <b-col cols="4"><BaseTextOutput label="Email Address" :value="application.emailAddress"/></b-col>
                  </b-row>

                  <h2 class="mt-3">Other Names</h2>
                  <OtherNames :value="application.otherNames"/>

                  <h2 class="mt-3">Trade Names</h2>
                  <TradeNames :value="application.tradeNames"/>

            </div>
        </div>

        </b-container>
        <b-modal id="affirm-modal" hide-header hide-footer>
            <h2>Affirm</h2>
            <hr/>
            <form ref="form" @submit.prevent="affirm">
                You are about to affirm your <span v-if="application.subCategory === 'TEMPORARY'">supervision</span>
                <span v-if="application.subCategory === 'GUEST'">sponsorship</span> for the application from user {{application.firstName}} {{application.lastName}}
                <p class="mt-2">Press Confirm to affirm or Cancel to return to the application review.</p>
                <div>
                    <b-button @click="closeAffirmModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary">Confirm</b-button>
                </div>
            </form>
        </b-modal>
        <b-modal id="deny-modal" hide-header hide-footer>
            <h2>Do Not Affirm</h2>
            <hr/>
            <form ref="form" @submit.prevent="deny">
                You are about to refuse to affirm your <span v-if="application.subCategory === 'TEMPORARY'">supervision</span>
                <span v-if="application.subCategory === 'GUEST'">sponsorship</span> for the application from user {{application.firstName}} {{application.lastName}}
                <p class="mt-2">Press Confirm to refuse affirmation or Cancel to return to the application review.</p>
                <div>
                    <b-button @click="closeDenyModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary">Confirm</b-button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import { required, maxLength } from 'vuelidate/lib/validators'
import Address from '@/components/templates/Address.vue'
import OtherNames from '@/components/templates/OtherNames.vue'
import TradeNames from '@/components/templates/TradeNames.vue'

export default {
  components: {
    Address,
    OtherNames,
    TradeNames
  },

  data: () => ({
    application: {},
      affirmations: [],
      oldAffirmations: [],
      limit: false
  }),
  
  mounted() {
    this.loadApplication();
      this.loadPendingAffirmations();
      this.loadUserAffirmations();
      this.loadLimit();
  },

  validations: {
  },

  computed: {
  },

  methods: {
    loadApplication() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/supervisor/${this.$route.params.id}`)
        .then(response => { 
          if (!response.data) {
            // route to unauth page
          } else {
            this.application = response.data
          }
        })
    },
      loadLimit(){
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/supervisor/user/plan`)
            .then(response => {
                this.limit = response.data;
                console.log(this.limit);
            })
      },

    showAffirmModal() {
        this.$bvModal.show('affirm-modal')
    },

    closeAffirmModal() {
        this.$bvModal.hide('affirm-modal')
    },

    showDenyModal() {
        this.$bvModal.show('deny-modal')
    },

    closeDenyModal() {
        this.$bvModal.hide('deny-modal')
    },

    affirm() {
        this.submitToServer('affirm')
    },

    deny() {
      this.submitToServer('deny')
    },

      loadPendingAffirmations() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/supervisor/user/pending`)
              .then(response => {
                  this.affirmations = response.data;
                  this.aboveLimitSupervisees();
              })
      },

      loadUserAffirmations() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/supervisor/user`)
              .then(response => {
                  this.oldAffirmations = response.data;
                  this.aboveLimitSupervisees();
              })
      },


    submitToServer(action) {
      const payload = {
        applicationId: this.$route.params.id,
        licenseId: this.application.license.licenseNbr
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/supervisor/${action}`, payload)
        .then(response => { 
          if (action != 'save') {
           this.showRootToast("Application Updates", "Your affirmation decision has been updated.", "success")
           this.$router.push('/home')
          } else {
            this.showRootToast("Application Updates", "The comments have been updated.", "success")
          }
      })
    },



    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
            title: title,
            toaster: 'b-toaster-top-center',
            solid: true,
            variant: type,
            appendToast: true,
            noAutoHide:true
          })
        this.toastFocus()
    },
    toastFocus() {
        setTimeout(() => {
            let elem = document.getElementsByClassName("toast")
            elem = elem[elem.length-1]
            elem.focus()
        }, 100)
    },
  }
}
</script>

<style>
</style>